<template>
    <span v-if="basketCount > 0">{{ basketCount }}</span>
</template>

<script setup>
    import { onMounted, computed } from 'vue';
    import { useProductStore } from '../stores/_product-store.js';

    const store = useProductStore();

    const basketCount = computed(() => {
        return store.getBasketCount;
    });

    onMounted(() => {
        store.fetchBasketCount();
    });

</script>